// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__36ks3","left":"InfoRow_left__27ixT"};